import SezzleCard from "component/design-system/bnpl-widget/SezzleCard";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import FaqAccordion from "container/FaqAccordion";
import { useTranslation } from "next-i18next";
import dynamic from "next/dynamic";
import HideIf from "util/HideIf";
import styles from "./styles.module.scss";
const FlexitiCard = dynamic(() => import(/* webpackChunkName: "flexiti-card" */"component/design-system/bnpl-widget/FlexitiCard"));

function PaymentType(props: any) {
  const { data, faqs } = props;
  const { t } = useTranslation();
  const tagLine = t(data.tagLine);

  return (
    <div className="d-flex flex-column align-items-center">
      <div className={styles.imgContainer}>

        <img
          className={styles.paymentTypeLogo}
          src={data.imgLogo}
          alt={tagLine}
        />
      </div>
      <HideIf show={data.id === "sezzle"}>
        <SezzleCard showHeader={false} points_className={styles.points} text_2_container_class={styles.text_2_container_class} />
      </HideIf>
      <HideIf show={data.id === "flexiti"}>
        <FlexitiCard
          tagLine={t("Select Flexiti at checkout to apply")}
          header={(
            <>
              {t("Get instantly approved")}
              <sup>1</sup>
              {" "}
              &nbsp;
              {t("for 0% financing*")}
            </>
          )}
          points_className={styles.points}
          footerTagLine={t("sezzle_footer_line")}
          point2={t("Simply select Flexiti at checkout to apply and get approved for 0% financing* in minutes")}
          flexiti_image_class={styles.flexiti_card_finance_page}
        />
      </HideIf>

      <div className="m-t-30 m-b-40" style={{ width: "100%" }}>

        <FaqAccordion faqs={faqs} />
      </div>
      <HideIf show={data.id === "sezzle"}>
        <PAText color="medium-grey" fontSize={FONT_SIZE[0]}>
          <sup>2</sup>
          {t("sezzle_footer_line_2")}
        </PAText>
      </HideIf>
      <HideIf show={data.id === "flexiti"}>
        <PAText color="medium-grey" fontSize={FONT_SIZE[0]}>
          {t("flexiti_footer_line_1")}
          <br />
          {" "}
          <br />
          <sup>1</sup>
          {t("flexiti_footer_line_2")}
        </PAText>
      </HideIf>
    </div>
  );
}

export default PaymentType;
